/* Keep the app's counter and click behavior; hide only its empty badge. */
(() => {
  const hosts = new WeakSet();
  function init() {
    document.querySelectorAll('.header-sections xb-wishlist-header').forEach(host => {
      if (hosts.has(host)) return;
      hosts.add(host);
      const refresh = () => host.querySelectorAll('.xb-product-quantity').forEach(badge => {
        const empty = badge.textContent.trim() === '0' || badge.textContent.trim() === '';
        badge.toggleAttribute('data-vnk-empty-count', empty);
      });
      refresh();
      new MutationObserver(refresh).observe(host, { childList:true, subtree:true, characterData:true });
    });
  }
  init();
  new MutationObserver(init).observe(document.body, { childList:true, subtree:true });
})();
